// 배포시 운영으로 변경해야함 // 빌드후 서버 dist 위치할경우 '/'
// export const DOMAIN = "http://192.168.0.11:8080"; // 로컬개발
export const DOMAIN = "https://api.uni-core.co.kr";
